import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(localeEs);

if (environment.production) {
  enableProdMode();
}

/** Carga el script de Google Maps con la API_KEY del environment antes de iniciar la app (necesario en build). */
function loadGoogleMapsScript(): Promise<void> {
  const apiKey = (environment as { API_KEY?: string }).API_KEY;
  if (!apiKey) {
    console.warn('Google Maps: API_KEY no definida en environment');
    return Promise.resolve();
  }

  (window as any).gm_authFailure = () => {
    const origin = window.location.origin;
    const href = window.location.href;
    const keyHint = apiKey ? `${apiKey.slice(0, 8)}…${apiKey.slice(-4)}` : '(sin key)';
    console.error(
      `[Google Maps] RefererNotAllowedMapError\n` +
      `  Origen: ${origin}\n` +
      `  URL: ${href}\n` +
      `  API key: ${keyHint}\n` +
      `  En GCP agrega también "${origin}" sin /* (el navegador a veces no envía la ruta).`
    );
  };

  const id = 'google-maps-api';
  if (document.getElementById(id) && (window as any).google?.maps) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    (window as any).gmapsCallback = () => resolve();
    const script = document.createElement('script');
    script.id = id;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places,geometry,drawing&callback=gmapsCallback`;
    script.async = true;
    script.defer = true;
    // HTTP→HTTPS: política por defecto del navegador envía solo el origen (sin ruta).
    script.referrerPolicy = 'no-referrer-when-downgrade';
    script.onerror = () => reject(new Error('Error al cargar Google Maps'));
    document.body.appendChild(script);
  });
}

loadGoogleMapsScript()
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch((err) => console.error(err));
